import * as React from "react";
import {IconProps} from "./IconProps";

export const IconMarketplace = React.forwardRef<SVGSVGElement, IconProps>(
    ({color = "currentColor", ...props}, forwardedRef) => {
        return (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
                ref={forwardedRef}
            >
                <path d="M5.93753 3.0072L0 11.917L2.68855 13.5733L8.62608 4.6635L5.93753 3.0072Z" fill={color ? color: "#0078D3"} />
                <path d="M12.0948 3.00964L6.15723 11.9194L8.84578 13.5757L14.7833 4.66594L12.0948 3.00964Z"
                      fill={color ? color: "#00AEFF"}/>
                <path
                    d="M14.5774 4.67634C14.0994 5.41308 13.8388 6.27794 13.8388 7.16416C13.8388 8.74441 14.6426 10.1965 16.0003 11.0507L14.2841 13.6667C12.0248 12.2359 10.667 9.80147 10.667 7.16416C10.667 5.68001 11.0906 4.23857 11.9053 3"
                    fill={color ? color: "#00AA00"}/>
                <path
                    d="M11.9372 3C11.1015 4.31886 10.667 5.85375 10.667 7.43411C10.667 8.44599 10.8453 9.42377 11.1795 10.3333L14.667 4.79638L11.9372 3Z"
                    fill={color ? color: "#25477B"}/>
            </svg>
        );
    },
);
